import { CognitoUserPool } from "amazon-cognito-identity-js";
import * as config from "./utils/config";

const poolData = {
    UserPoolId: config.COGNITO_POOL_ID,
    ClientId: config.COGNITO_CLIENT_ID,
}

export default new CognitoUserPool(poolData);